webpackJsonp([18994563585294],{

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _styles = __webpack_require__(11);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Paper = __webpack_require__(92);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gradient = __webpack_require__(83);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _banner = __webpack_require__(67);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _quote = __webpack_require__(68);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _site = __webpack_require__(43);
	
	var _site2 = _interopRequireDefault(_site);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThingsPage = function ThingsPage(props) {
	  var classes = props.classes;
	
	  var metadata = (0, _mapper.mapMetaData)(props.data.things);
	  var things = (0, _mapper.mapThings)(props.data.things);
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_metadata2.default, { data: metadata }),
	    _react2.default.createElement(_banner2.default, { uid: 'contact', title: things.title, subtitle: things.subtitle }),
	    _react2.default.createElement(Things, { data: things }),
	    _react2.default.createElement(_footer2.default, { policies: props.data.policies.edges })
	  );
	};
	
	var Things = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      data = props.data;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.channels },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12 },
	            _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'display1', className: classes.channelTitle },
	              _react2.default.createElement(_gradient2.default, {
	                text: data.title.text,
	                fromColor: '#79BC62',
	                toColor: '#0087FC',
	                direction: 'left'
	              })
	            ),
	            _react2.default.createElement(
	              _Typography2.default,
	              null,
	              data.intro.text
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: classes.thingsItemsList },
	              data.list.map(function (thing, index) {
	                return _react2.default.createElement(Thing, { key: index, data: thing, index: index, classes: classes });
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	var Thing = function Thing(props) {
	  var data = props.data,
	      index = props.index,
	      classes = props.classes;
	
	  return _react2.default.createElement(
	    _Paper2.default,
	    { className: classes.thingsItem, elevation: 0 },
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, spacing: 16 },
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12, sm: 4, style: {
	            display: 'flex', alignItems: 'flex-start'
	          } },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.logo.sizes, className: classes.thingsItemLogo })
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12, sm: 8 },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            { className: classes.thingsItemText },
	            data.intro.text.substr(0, 150) + ' ...'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              variant: 'outlined',
	              component: _gatsbyLink2.default,
	              to: '/things/' + data.uid,
	              size: 'small',
	              className: classes.thingsItemButton
	            },
	            'Find out more'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_site2.default)(ThingsPage);
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-things-js-41c7fbebe30a72e79606.js